import React, { useState, useEffect, useRef } from "react";
import Container from "../../../components/layout/Container/Container";
import { IInspectionResponseModel } from "../../../typings/models/InspectionResponseModel";
import InspectionGrid from "./InspectionGrid";
import { getInspections } from "../../../api/apimethods";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useAuthService, useContextService } from "../../../services";
import { useLocation } from "react-router-dom";

const InspectionDashboard: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const inspectionRef = useRef(true);
  const [data, setData] = useState<IInspectionResponseModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const bannerType = location.state;
  const tab = location.state?.activeTab;

  useEffect(() => {
    if (inspectionRef.current) {
      inspectionRef.current = false;
      const fetchData = async () => {
        try {
          const response = await getInspections("Harvest", user.idNo);
      
          setData(response.data);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }
  }, []);

  return (
    <>
      {/* <Header /> */}
      <Container>
        {/* <Banner name="DragonFish all schedule tasks" uiClass="banner-bg" /> */}
        {/* <h3>My all tasks</h3> */}
        <div>
          <h1 className="csp-color-02763A">Harvest Inspections</h1>
          <InspectionGrid data={data} isLoading={isLoading} />
        </div>
      </Container>
    </>
  );
};

export default InspectionDashboard;
